import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { components } from 'react-select';

import style from './clear-indicator.module.less';

const ReactSelectClearIndicator = components.ClearIndicator;

/**
 * @typedef {import('react-select').ClearIndicatorProps} ClearIndicatorProps
 */

/**
 * @param {ClearIndicatorProps} props
 * @returns {JSX.Element}
 */
export const ClearIndicator = (props) => {
  return (
    <ReactSelectClearIndicator {...props}>
      <FontAwesomeIcon className={style['clear-indicator-icon']} icon={faTimes} />
    </ReactSelectClearIndicator>
  );
};
